<template>
  <div style="margin-top:-10px !important">
    <b-row class="px-pad border-bottom" style="height:42px">
      <b-col md="6" lg="6" sm="6" cols="6" class="px-0">
        <span class="fw-semi-bold index-heading pl-0">User Role</span>
      </b-col>
      <b-col md="6" lg="6" sm="6" cols="6" class="text-right px-0">
        <router-link
          :to="{ name : 'UserRoleCreate'}"
          v-if="RoutePermission(false,'','invoice','settings','userrole')"
        >
          <b-button variant="primary" size="sm">New Role</b-button>
        </router-link>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="px-0">
        <div class="table-responsive px-0 min-table">
          <table class="table table-hover not-fixed-col not-fixed-last-col index-table">
            <thead>
              <tr>
                <th style="padding-left: 1.6rem !important;width:40px !important">S.No</th>
                <th style="width:150px !important">Role Name</th>
                <th style="width:200px !important">Description</th>
                <th
                  class="text-right"
                  style="width:30px !important;padding-right: 1.6rem !important;"
                ></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(list,index) in lists" :key="index">
                <td style="width:40px !important;padding-left: 1.6rem !important;">{{ index + 1}}</td>
                <td style="width:150px !important">
                  <span class="text pr-3">{{ list.role_name }}</span>
                </td>
                <td style="width:200px !important">
                  <span class="text pr-3">{{ list.role_desc }}</span>
                </td>
                <td class="text-right cursor_pointer" style="padding-right: 1.6rem !important;">
                  <b-dropdown
                    right
                    v-if="list.role_name != 'admin'"
                    toggle-class="text-decoration-none"
                    variant="link"
                    no-caret
                    size="xs"
                    class="table-hover-visible last-td-arrow"
                  >
                    <template slot="button-content">
                      <i
                        class="glyphicon glyphicon-option-vertical theme-text-color"
                        style="top:-6px !important;letter-spacing:-5px !important"
                      ></i>
                    </template>
                    <router-link
                      v-if="list.role_name != 'admin'&&RoutePermission(false,'','invoice','settings','userrole')"
                      class="event-link dropdown-item"
                      :to="{ name : 'UserRoleUpdate',params:{id:list.role_id}}"
                    >Edit</router-link>
                    <router-link
                      v-if="list.role_name != 'admin'&&RoutePermission(false,'','invoice','settings','userrole')"
                      class="event-link dropdown-item"
                      :to="{ name : 'UserRoleCreate',query:{clone_id:list.role_id}}"
                    >Clone</router-link>
                    <span
                      v-if="list.role_name != 'admin'"
                      v-b-modal.deleteuserrole
                      @click="deleteid = list.role_id, deleteindex = index"
                      class="event-link dropdown-item"
                    >Delete</span>
                  </b-dropdown>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-col>
    </b-row>
    <!--  user role delete modal -->
    <b-modal
      id="deleteuserrole"
      size="sm"
      ref="deleteuserrole"
      body-class="bg-white"
      cancel-title="Cancel"
      cancel-variant="light"
      ok-title="Delete"
      :title="'Delete User Role'"
      @ok="deleteuserrole"
    >
      <p>Are you sure you want to delete this role?</p>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import store from "@/store/index";
import { notificationMixin } from "@/mixins/notification";
function getUserRole(routeTo, next) {
  store
    .dispatch(
      "userrole/fetchLists",
      JSON.stringify({
        app_id: process.env.VUE_APP_APP_ID
      })
    )
    .then(() => {
      next();
    });
}
export default {
  mixins: [notificationMixin],
  data() {
    return {
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      deleteindex: "",
      deleteid: ""
    };
  },
  methods: {
    //  delete whole invoice
    deleteuserrole() {
      this.$store
        .dispatch(
          "userrole/deleteuserrole",
          JSON.stringify({
            id: this.deleteid
          })
        )
        .then(() => {
          this.deleteid = "";
          this.$refs.deleteuserrole.hide();
          //  code for notificatin display
          var message;
          var type;
          if (this.code == 200) {
            message = " The user role has been deleted successfully";
            this.lists.splice(this.deleteindex, 1);
            type = "success";
          } else {
            message = " Sorry this role cannot be deleted.";
            type = "danger";
          }
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: message,
            type: type,
            showCloseButton: true
          });
        });
    }
  },
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },

  beforeRouteEnter(routeTo, routeFrom, next) {
    getUserRole(routeTo, next);
  },
  computed: {
    ...mapState({
      lists: state => state.userrole.lists,
      code: state => state.userrole.code
    })
  }
};
</script>

<style>
</style>
